import {Injectable} from "@angular/core";
import {IDropdownItem} from "@irb-common/models/dropdown.model";
import {IrbAppEvents} from "@irb/app.events";
import {AppService} from "@irb/app.service";
import {DeleteHeaderComponent} from "@irb-common/components/grid/renderers/delete.header.component";
import {DeleteCellComponent} from "@irb-common/components/grid/renderers/delete.cell.component";
import {CheckboxCellComponent} from "@irb-common/components/grid/renderers/checkbox.cell.component";
import {NumberTextBoxRendererComponent} from "@irb-common/components/grid/renderers/number-text-box.cell.component";
import {DropdownSearchRendererComponent} from "@irb-common/components/grid/renderers/dropdown-search.cell.component";


@Injectable({
  providedIn: "root"
})
export class TlhRebalanceSettingsGridLayoutService  {
  constructor() {
  }

  getFrameworkComponents() {
    return {
      "DeleteHeaderComponent": DeleteHeaderComponent,
      "DeleteCellComponent": DeleteCellComponent,
      "CheckboxCellComponent": CheckboxCellComponent,
      "NumberTextBoxRendererComponent": NumberTextBoxRendererComponent,
      "DropdownSearchRendererComponent": DropdownSearchRendererComponent
    };
  }

  getColumnDefs(parent: any) {
    return [
      {
        headerName: "Delete All",
        headerComponent: "DeleteHeaderComponent",
        headerComponentParams: {
          message: "Remove all Entries?",
          proceed: parent.deleteAll.bind(parent),
          cancel: parent.cancelDelete.bind(parent),
        },
        cellRenderer: "DeleteCellComponent",
        cellRendererParams: {
          message: "Remove this Entry?",
          proceed: parent.delete.bind(parent),
          cancel: parent.cancelDelete.bind(parent),
        },
        resizable: false,
        minWidth: 25,
        maxWidth: 25,
        width: 25,
        pinned: "left",
      },
      {
        headerName: "Harvest",
        children: [
          {
            headerName: "Symbol",
            field: "harvestSecSymb",
            colId: "harvestSecSymb",
            cellRenderer : 'cellRendererFormatter',
            cellClass: 'excelString',
            resizable: true,
            width: 140,
            minWidth: 100,
            sort: "asc"
            ,suppressMovable: true
          },
        ],
      },
      {
        headerName: " Minimum Loss Threshold",
        headerGroupComponent: "customHeaderGroup",
        headerGroupComponentParams: {
          irbColInfo: this.sellIfLossInfo(),
        },
        children: [
          {
            headerName: "Min %",
            field: "percentageAmount",
            colId: "percentageAmount",
            resizable: true,
            width: 120,
            minWidth: 120,
            cellClass: ["numberTextBoxCell", "percentageCell"],
            cellRenderer: "NumberTextBoxRendererComponent",
            cellRendererParams: () => {
              return {
                min: '0',
                max: 100,
                places: 2,
                isPercentage: true,
                invalidRangeMessage: 'Please enter a value between 0..100',
                editIconOnHover: true,
                onChange: (params: any, c: any) => {
                  if (params.data.percentageAmount !== c.value && c.isValid) {
                    params.data.percentageAmount = parseFloat(c.value);
                    params.api.redrawRows({rowNodes: [params.node]});
                  }
                },
              };
            }
            ,suppressMovable: true
          },
          {
            headerName: "Min $",
            field: "dollarAmount",
            colId: "dollarAmount",
            resizable: true,
            width: 120,
            minWidth: 120,
            cellClass: ["numberTextBoxCell", "excelUSD"],
            cellRenderer: "NumberTextBoxRendererComponent",
            excelStyles: ['priceUSD'],
            cellRendererParams: () => {
              return {
                min: '0',
                max: 9999999,
                places: 2,
                isCurrency: true,
                invalidRangeMessage: 'Number must be 0 or greater',
                editIconOnHover: true,
                onChange: (params: any, c: any) => {
                  if (params.data.dollarAmount !== c.value && c.isValid) {
                    params.data.dollarAmount = parseFloat(c.value);
                    params.api.redrawRows({rowNodes: [params.node]});
                  }
                },
              };
            }
            ,suppressMovable: true
          },
        ],
      },
      {
        headerName: "Replace with",
        headerGroupComponent: "customHeaderGroup",
        headerGroupComponentParams: {
          irbColInfo: this.replaceWithInfo(),
        },
        children: [
          {
            headerName: "Primary",
            field: "primarySecSymb",
            colId: "primarySecSymb",
            suppressFiltersToolPanel: true,
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["reset", "apply"],
              newRowsAction: "keep",
              suppressSorting: true,
              cellHeight: 30,
              closeOnApply: true
            },
            cellClass: ["dropdownSearchCell", "excelString"],
            cellRenderer: "DropdownSearchRendererComponent",
            cellRendererParams: (params: any) => {
              const addNewItemConfig = {
                button: 'Add new security',
                type: 'security',
                fromComp: 'TLHRebalanceGridLayoutService',
                rowIndex: params.rowIndex || params.node.rowIndex,
                primary: true
              };
              const securitiesForColumn = parent.securitiesWithOutCash || [];
              return {
                placeholder: "None",
                defaultValue: {name: params.data.primarySecSymb, value: params.data.primarySecId},
                topArrayElements: [{name: '$CASH (Leave in Cash)', value: parent.cashSecurity.value}],
                values: JSON.parse(JSON.stringify(securitiesForColumn)),
                editIconOnHover: true,
                hoverPanelWidth: 200,
                addNewItemConfig: addNewItemConfig,
                onChange: (params: any, item: IDropdownItem) => {
                  parent.securityTargetData.forEach((element: any) => {
                    if (element.securitySymbol === item.name) {
                      params.data.primarySecType = element.securityType;
                    }
                  });
                  params.data.primarySecId = item.value;
                  params.data.primarySecSymb = item.name;
                  if (params.data.primarySecId === parent.cashSecurity.value) {
                    params.data.secondarySecId = null;
                    params.data.secondarySecSymb = null;
                    params.data.secondarySecType = null;
                  } else if (params.data.primarySecId === params.data.secondarySecId || !params.data.secondarySecId || params.data.secondarySecId === -1) {
                    params.data.secondarySecId = null;
                    params.data.secondarySecSymb = null;
                    params.data.secondarySecType = null;
                  }
                  params.api.redrawRows({rowNodes: [params.node]});
                  parent.emitChange();

                  //parent.warnIfSymbolUsedAsEquityReplaceTarget(params.data.primarySecSymb);
                },
                openNewItemFlow: (dataParam: any) => {
                  dataParam = Object.assign({}, addNewItemConfig, dataParam);
                  parent.openNewItemSecurityFlow(dataParam, true);
                },
                onClearSelection: (params: any) => {
                  params.data.primarySecId = null;
                  params.data.primarySecSymb = null;
                  params.data.primarySecType = null;
                  params.data.secondarySecId = null;
                  params.data.secondarySecSymb = null;
                  params.data.secondarySecType = null;
                  params.api.redrawRows({rowNodes: [params.node]});
                  parent.emitChange();
                },
              };
            },
            resizable: false,
            minWidth: 180
            ,suppressMovable: true
          },
          {
            headerName: "Secondary",
            field: "secondarySecSymb",
            colId: "secondarySecSymb",
            suppressFiltersToolPanel: true,
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["reset", "apply"],
              newRowsAction: "keep",
              suppressSorting: true,
              cellHeight: 30,
              closeOnApply: true
            },
            cellClass: ["dropdownSearchCell", "excelString"],
            cellRenderer: "DropdownSearchRendererComponent",
            cellRendererParams: (params: any) => {
              const disabledEdit = params.data.primarySecId === parent.cashSecurity.value || !params.data.primarySecId;
              let secondarySecurityTargets: any = parent.securitiesWithOutCash ? JSON.parse(JSON.stringify(parent.securitiesWithOutCash)) : [];
              if (params.data.primarySecId !== parent.cashSecurity.value) {
                secondarySecurityTargets = secondarySecurityTargets.filter((sec: any) => sec.value !== params.data.primarySecId);
              }
              const topArrayElements = [
                {name: '$CASH (Leave in Cash)', value: parent.cashSecurity.value},
              ];
              const addNewItemConfig = {
                button: 'Add new security',
                type: 'security',
                fromComp: 'TLHRebalanceGridLayoutService',
                rowIndex: params.rowIndex || params.node.rowIndex,
                primary: false
              };
              return {
                placeholder: "None",
                defaultValue: {name: params.data.secondarySecSymb, value: params.data.secondarySecId},
                values: secondarySecurityTargets,
                topArrayElements: topArrayElements,
                editIconOnHover: true,
                hoverPanelWidth: 200,
                disabled: () => disabledEdit,
                addNewItemConfig: addNewItemConfig,
                onChange: (params: any, item: IDropdownItem) => {
                  if (item.value !== params.data.primarySecId) {
                    parent.securityTargetData.forEach((element: any) => {
                      if (element.securitySymbol === item.name) {
                        params.data.secondarySecType = element.securityType;
                      }
                    });
                    params.data.secondarySecId = item.value;
                    params.data.secondarySecSymb = item.name;
                  }
                  params.api.redrawRows({rowNodes: [params.node]});
                  parent.emitChange();
                },
                openNewItemFlow: (dataParam: any) => {
                  dataParam = Object.assign({}, addNewItemConfig, dataParam);
                  parent.openNewItemSecurityFlow(dataParam, true);
                },
                onClearSelection: (params: any) => {
                  params.data.secondarySecId = null;
                  params.data.secondarySecSymb = null;
                  params.data.secondarySecType = null;
                  params.api.redrawRows({rowNodes: [params.node]});
                  parent.emitChange();
                },
              };
            },
            resizable: false,
            minWidth: 180
            ,suppressMovable: true
          },
          {
            headerName: "Swap / Exchange",
            field: "isSwapExchange",
            colId: "isSwapExchange",
            minWidth: 90,
            cellRenderer: "CheckboxCellComponent",
            cellRendererParams: (params: any) => {
              let swapExchNotAllowed = params.data.harvestSecType !== 'MUTUAL_FUND' || params.data.primarySecType !== 'MUTUAL_FUND';
              if (!swapExchNotAllowed) {
                if (params.data.secondarySecType !== 'MUTUAL_FUND' && params.data.secondarySecType !== 'CASH')
                  swapExchNotAllowed = true;
              }
              if (swapExchNotAllowed && params.data.isSwapExchange) {
                params.data.isSwapExchange = false;
              }

              return {
                value: params.data.isSwapExchange,
                isDisabled: swapExchNotAllowed,
                onChange: (newValue: boolean) => {
                  params.data.isSwapExchange = newValue;
                  parent.emitChange();
                }
              }
            },
            suppressFiltersToolPanel: true,
            cellStyle: {"text-align": "center"}
            ,suppressMovable: true
          },
        ]
      }

    ]
  }

  sellIfLossInfo() {
    let msg = `iRebal will evaluate holdings in taxable accounts for each security that you list here. iRebal will first look at the % loss, either at the lot or position level based on your loss detection level setting below, and select only those (lots or positions) that exceed the % threshold you specify. Next, looking only at lots or positions that passed the % threshold check, iRebal will propose a sale only if the $ loss on the total sale of the security in the account will exceed the $ amount threshold you specify.`;
    return msg;
  }

  replaceWithInfo() {
    let msg = `You can tell iRebal to purchase a security in place of the security being sold, or you can choose to leave the proceeds of the sale in cash. You may select different replacement securities for each harvested security. In order to mitigate wash sale concerns, the security which is purchased to replace a harvested security will be considered as equivalent to the security sold if the portfolio is rebalanced within the next 30 days.`;
    return msg;
  }
}
